// import React from "react";

// const OurLeadersipTeam = () => {
//   return (
//     <div>
//       <section className="py-16 px-4 md:px-20 bg-gray-50">
//         <h2 className="text-2xl font-bold mb-10 text-center">
//           RGCC Leadership Team
//         </h2>
//         <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">
//           {[
//             {
//               name: "Maj Gen Mohammad Kamrul Hasan, SGP, SUP, ndc, hdmc, psc",
//               title: "President",
//               image:
//                 "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754892864/TF00001_passport-min_f4iuzp.jpg",
//             },

//             {
//               name: "Brig Gen Emranul Hasan, BGMS",
//               title: "Vice President",
//               image:
//                 "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113122/WhatsApp_Image_2025-08-14_at_1.05.08_AM_zsobp3.jpg",
//             },
//             {
//               name: "Col Muhammad Rubayat Zamil, BSP",
//               title: "Golf Capt",
//               image:
//                 "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113121/WhatsApp_Image_2025-08-14_at_1.05.06_AM_ma8v7s.jpg",
//             },
//             {
//               name: "Lt Col Arif Billah, psc",
//               title: "Member Secretary",
//               image:
//                 "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113122/WhatsApp_Image_2025-08-14_at_1.05.011_AM_uiepq2.jpg",
//             },
//             {
//               name: "Maj Md Faysal Hasan Khan, SUP",
//               title: "Asst Member Secretary",
//               image:
//                 "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113121/WhatsApp_Image_2025-08-14_at_1.05.07_AM_l3579p.jpg",
//             },
//             {
//               name: "Capt Nasreen Haque Boby",
//               title: "Lady Golf Capt",
//               image:
//                 "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754933491/no-profile_ha50x4.jpg",
//             },
//             // { name: "John Reti", title: "Lady Golf Captain", image: img2 },
//           ].map((member, i) => (
//             <div
//               key={i}
//               className="text-center border rounded-[5px] p-[5px] hover:"
//             >
//               <img
//                 src={member.image}
//                 alt={member.name}
//                 className="w-32 h-32 mx-auto rounded-full object-cover mb-4"
//               />
//               <h4 className="font-bold">{member.name}</h4>
//               <p className="text-sm text-gray-600">{member.title}</p>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default OurLeadersipTeam;

import React from "react";

const OurLeadersipTeam = () => {
  const teamMembers = [
    {
      name: "Maj Gen Mohammad Kamrul Hasan, SGP, SUP, ndc, hdmc, psc",
      title: "President",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754892864/TF00001_passport-min_f4iuzp.jpg",
    },
    {
      name: "Brig Gen Emranul Hasan, BGMS",
      title: "Vice President",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113122/WhatsApp_Image_2025-08-14_at_1.05.08_AM_zsobp3.jpg",
    },
    {
      name: "Col Muhammad Rubayat Zamil, BSP",
      title: "Golf Capt",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113121/WhatsApp_Image_2025-08-14_at_1.05.06_AM_ma8v7s.jpg",
    },
    {
      name: "Lt Col Arif Billah, psc",
      title: "Member Secretary",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113122/WhatsApp_Image_2025-08-14_at_1.05.011_AM_uiepq2.jpg",
    },
    {
      name: "Maj Md Faysal Hasan Khan, SUP",
      title: "Asst Member Secretary",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113121/WhatsApp_Image_2025-08-14_at_1.05.07_AM_l3579p.jpg",
    },
    {
      name: "Capt Nasreen Haque Boby",
      title: "Lady Golf Capt",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755166080/WhatsApp_Image_2025-08-14_at_4.06.11_PM_ni5t14.jpg",
    },
  ];

  const [president, ...otherMembers] = teamMembers;

  return (
    <div>
      <section className="py-5 px-4 md:px-20 bg-gray-50">
        <h2 className="text-2xl font-bold mb-5 text-center uppercase">
          RGCC Leadership Team
        </h2>

        {/* President Card - Larger and centered at top */}
        <div className="flex justify-center mb-5">
          <div className="text-center border rounded-[5px] p-6 max-w-md w-full shadow-lg bg-white">
            <img
              src={president.image}
              alt={president.name}
              className="w-48 h-48 mx-auto rounded-full object-cover mb-6 border-4 border-gold-500"
            />
            <h4 className="font-bold text-lg">{president.name}</h4>
            <p className="text-md text-gray-600 font-semibold">
              {president.title}
            </p>
          </div>
        </div>

        {/* Other Team Members */}
        <div className="grid sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10 overflow-x-scroll">
          {otherMembers.map((member, i) => (
            <div
              key={i}
              className="text-center border rounded-[5px] p-[5px] hover:shadow-md transition-shadow bg-white"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-32 h-32 mx-auto rounded-full object-cover mb-4"
              />
              <h4 className="font-bold">{member.name}</h4>
              <p className="text-sm text-gray-600">{member.title}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default OurLeadersipTeam;
